var DAY_IN_MS = 1000 * 60 * 60 * 24;
var MORNING_START = 1000 * 60 * 60 * 3;
var EVENING_START = 1000 * 60 * 60 * 18;
var NIGHT_START = 1000 * 60 * 60 * 23;
export var getStartOfDayInMS = function (date) {
    if (date === void 0) { date = new Date(); }
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
};
export var isMoreThan7DaysAgo = function (date, now) {
    if (now === void 0) { now = new Date(); }
    var ms6DaysAgo = getStartOfDayInMS(now) - DAY_IN_MS * 6;
    return date.getTime() < ms6DaysAgo;
};
export var isBetween2And6DaysAgo = function (date, now) {
    if (now === void 0) { now = new Date(); }
    var nowStartOfDayInMS = getStartOfDayInMS(now);
    var ms1DayAgo = nowStartOfDayInMS - DAY_IN_MS;
    var ms6DaysAgo = nowStartOfDayInMS - DAY_IN_MS * 6;
    return date.getTime() >= ms6DaysAgo && date.getTime() < ms1DayAgo;
};
export var isYesterday = function (date, now) {
    if (now === void 0) { now = new Date(); }
    var nowStartOfDayInMS = getStartOfDayInMS(now);
    var msYesterdayStart = nowStartOfDayInMS - DAY_IN_MS;
    var msYesterdayEvening = msYesterdayStart + NIGHT_START;
    return date.getTime() >= msYesterdayStart && date.getTime() < msYesterdayEvening;
};
export var isLastNight = function (date, now) {
    if (now === void 0) { now = new Date(); }
    var nowStartOfDayInMS = getStartOfDayInMS(now);
    var msYesterdayEvening = nowStartOfDayInMS - DAY_IN_MS + NIGHT_START;
    var msThisMorning = nowStartOfDayInMS + MORNING_START;
    return date.getTime() >= msYesterdayEvening && date.getTime() < msThisMorning;
};
export var isToday = function (date, now) {
    if (now === void 0) { now = new Date(); }
    var nowStartOfDayInMS = getStartOfDayInMS(now);
    var msTodayStart = nowStartOfDayInMS + MORNING_START;
    var msThisEvening = nowStartOfDayInMS + EVENING_START;
    return date.getTime() >= msTodayStart && date.getTime() < msThisEvening;
};
export var isThisEvening = function (date, now) {
    if (now === void 0) { now = new Date(); }
    var nowStartOfDayInMS = getStartOfDayInMS(now);
    var msThisEvening = nowStartOfDayInMS + EVENING_START;
    var msTonight = nowStartOfDayInMS + NIGHT_START;
    return date.getTime() >= msThisEvening && date.getTime() < msTonight;
};
export var isTonight = function (date, now) {
    if (now === void 0) { now = new Date(); }
    var nowStartOfDayInMS = getStartOfDayInMS(now);
    var msTonight = nowStartOfDayInMS + NIGHT_START;
    var msTomorrowMorning = nowStartOfDayInMS + DAY_IN_MS + MORNING_START;
    return date.getTime() >= msTonight && date.getTime() < msTomorrowMorning;
};
export var isTomorrow = function (date, now) {
    if (now === void 0) { now = new Date(); }
    var nowStartOfDayInMS = getStartOfDayInMS(now);
    var msTomorrowMorning = nowStartOfDayInMS + DAY_IN_MS + MORNING_START;
    var ms2Days = nowStartOfDayInMS + DAY_IN_MS * 2;
    return date.getTime() >= msTomorrowMorning && date.getTime() < ms2Days;
};
export var isBetween2And6Days = function (date, now) {
    if (now === void 0) { now = new Date(); }
    var nowStartOfDayInMS = getStartOfDayInMS(now);
    var ms7Days = nowStartOfDayInMS + DAY_IN_MS * 7;
    var ms2Days = nowStartOfDayInMS + DAY_IN_MS * 2;
    return date.getTime() >= ms2Days && date.getTime() < ms7Days;
};
export var isMoreThan7Days = function (date, now) {
    if (now === void 0) { now = new Date(); }
    var nowStartOfDayInMS = getStartOfDayInMS(now);
    var ms7Days = nowStartOfDayInMS + DAY_IN_MS * 7;
    return date.getTime() >= ms7Days;
};
//# sourceMappingURL=dateUtils.js.map